import { CartesianChart } from "./CartesianChart";
import type {
  ChartInteraction,
  ChartMask,
  ChartVariant,
  LineChartSpec,
} from "./types";

/** Line chart for trends over an ordered category (usually time). */
export function LineChart({
  spec,
  variant,
  mask,
  ...interaction
}: {
  spec: LineChartSpec;
  variant: ChartVariant;
  mask?: ChartMask;
} & ChartInteraction) {
  return <CartesianChart spec={spec} variant={variant} mask={mask} {...interaction} />;
}
